import { css } from '@emotion/react';
import { proIcons } from './pro-icons';
import { getSize } from './svg-icon';
import { IconElementProps, IconName } from './types';

export * from './types';

export type IconProps = IconElementProps & {
  name: IconName;
};

export function Icon(props: IconProps): JSX.Element {
  const { name, color, size } = props;
  const IconComp = proIcons[name];
  return <IconComp size={size} color={color} />;
}

type PlainIconProps = IconElementProps & {
  name: IconName;
  backgroundColor: string;
  borderRadius?: number;
  className?: string;
};

export function PlainIcon(props: PlainIconProps): JSX.Element {
  const { backgroundColor, borderRadius, color, name, size, className } = props;
  return (
    <div
      className={className}
      css={css({
        backgroundColor,
        borderRadius: borderRadius || getSize(size),
      })}
    >
      <Icon name={name} size={size} color={color} />
    </div>
  );
}
